//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"LinearDimElevation",0,"Expression",0],[1,"LinearDimGateThickness",0,"Expression",0],[1,"LinearDimOpeningWidth",0,"Expression",0],[0,"OpeningAddGate",1,0],[0,"OpeningStyleEnum",1,0],[0,"ReverseDirection",1,0],[0,"SelectPoint",1,"Point",0]],[[[],"GetDirVector",{R_:{dirVector:"Direction"}},0,0],[["dirVector"],"SetDirVector",{},1,0],[["railingFrec"],"SetRailingFeature",{},1,0]],[]];
SPLM.LineDesigner.RailOpeningFeatureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.RailOpeningFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.RailOpeningFeatureBuilder.GateOpeningStyle = Object.freeze({
    "Left" : "Left", "Middle" : "Middle", "Right" : "Right"});

export default SPLM;